import { UserState, userRedux } from "./user/redux";
import { combineReducers } from "redux";
import { calendarReducer, CalendarState } from "./calendar/reducers";
import { CollectionsState, collectionReducer } from "./collections/reducers";

export interface AppState {
	currentUser?: UserState;
	calendarBooks: CalendarState;
	collections: CollectionsState;
}

export const rootReducer = combineReducers<AppState>({
	currentUser: userRedux,
	calendarBooks: calendarReducer,
	collections: collectionReducer
});
